import { Tooltip, Button } from '@fluentui/react-components';
import { InfoRegular } from '@fluentui/react-icons';
import React from 'react';
import { iconButtonStyles } from '../../app/common/styles/CommonStyleObjects';

interface IMessageWithTooltipProps {
  label: string;
  tooltipMessage: string;
}
const MessageWithTooltip = (props: IMessageWithTooltipProps): JSX.Element => {
  const { label, tooltipMessage } = props;
  return (
    <>
      {label}
      <Tooltip withArrow content={tooltipMessage} relationship="label">
        <Button
          appearance="subtle"
          size="small"
          aria-label="Info"
          icon={<InfoRegular color={iconButtonStyles.color} />}
        />
      </Tooltip>
    </>
  );
};
export default MessageWithTooltip;
